





















































import { Employe } from "../../models/Employe";
import Planning = Employe.Planning;
import DateInput from "../../core/Forms/DateInput.vue";
import { EmployeApi } from "../../api/EmployeApi";
import moment from "moment";

export default {
    name: "PlanningsRotation",
    components: { DateInput },
    props: {
        plannings: Array,
    },
    data() {
        return {
            mainPlanning: null,
            editDateEffet: false,
            dateEffetValue: null,
            EmployeApi: new EmployeApi(),
        };
    },
    computed: {
        dureeMoyenneHebdo() {
            let res = 0;
            _.forEach(this.plannings, function (planning: Planning) {
                res += planning.weekly_hours * planning.repetition;
            });
            res =
                res /
                _.chain(this.plannings)
                    .map("repetition")
                    .sumBy(function (val) {
                        return Number(val);
                    })
                    .value();
            return _.round(res, 2);
        },
    },
    watch: {
        plannings: {
            immediate: true,
            handler(val) {
                if (val.length > 0) {
                    this.mainPlanning = _.chain(this.plannings)
                        .sortBy("planning_id")
                        .first()
                        .value();
                }
            },
        },
    },
    methods: {
        toggleEditDateEffet() {
            this.editDateEffet = !this.editDateEffet;
            if (this.editDateEffet) {
                this.dateEffetValue = this.mainPlanning.start_date_str;
            }
        },
        saveDateEffet() {
            let self = this;

            let dateEffet = moment(self.dateEffetValue, "DD/MM/YYYY");
            if (!dateEffet.isValid()) {
                swal("Erreur", "Date invalide", "error");
                return;
            }
            if (dateEffet.day() !== 1) {
                dateEffet.day(1);
                swal(
                    "Warning",
                    "La date d'effet doit être un lundi, elle a été automatiquement modifiée au " +
                        dateEffet.format("DD/MM/YYYY"),
                    "warning"
                );
            }

            self.mainPlanning.start_date_str = dateEffet.format("DD/MM/YYYY");

            self.EmployeApi.updatePlanning(
                self.mainPlanning.employe_id,
                self.mainPlanning
            ).then(function (response) {
                self.toggleEditDateEffet();
            });
        },
        savePlanning(planning: Planning) {
            let self = this;
            return self.EmployeApi.updatePlanning(
                planning.employe_id,
                planning
            ).then(function (response) {
                return response;
            });
        },
    },
};
